module.exports = __webpack_public_path__ + "img/android-badge.448b6e4.png";